import useCategoryQuery from "@/shared/hooks/useCategoryQuery";
import { asArray } from "@/shared/utils/helpers";
import { Menu } from "@/shared/v2/queries/interfacesV2";
import { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

export const getKioskCategoriesWithProducts = (menu?: Menu | null) =>
  menu?.navigation_content?.filter(
    (category) =>
      (category.sub_content?.length ?? 0) > 0 &&
      (category.virtual_item_type === undefined ||
        category.virtual_item_type === 1)
  ) ?? [];

const useKioskCategory = (id: string, categoryId: string, redirect = true) => {
  const history = useHistory();
  const { data: menu, isPending, isSuccess } = useCategoryQuery(id);
  const categoriesWithProducts = useMemo(
    () => getKioskCategoriesWithProducts(menu),
    [menu]
  );
  const data = useMemo(
    () =>
      categoriesWithProducts.find(
        (category) => category.item_id === parseInt(categoryId)
      ),
    [categoriesWithProducts, categoryId]
  );

  useEffect(() => {
    if (isPending || !isSuccess || !redirect) return;
    if (data) return;

    const firstCategory = categoriesWithProducts[0];
    if (firstCategory) {
      history.replace(`/kiosk/menu/${id}/${firstCategory.item_id}`);
      return;
    }

    history.push("/kiosk/deliverymethods");
  }, [
    isSuccess,
    data,
    isPending,
    redirect,
    categoriesWithProducts,
    history,
    id,
  ]);

  const filters = useMemo(() => {
    let labels = new Set<string>();
    data?.sub_content?.forEach((product) =>
      asArray(product?.label)?.forEach(
        (label) => label !== "" && labels.add(label)
      )
    );

    return Array.from(labels);
  }, [data]);
  return { data, filters };
};

export default useKioskCategory;
